import { render, staticRenderFns } from "./EditCallPriceConfirmationModal.vue?vue&type=template&id=007fe00b"
import script from "./EditCallPriceConfirmationModal.vue?vue&type=script&lang=js"
export * from "./EditCallPriceConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports